import React from "react";
import { useRedirectBadge } from "./useRedirectBadge";

/**
 * La pastille rouge « Redirections (N) » de la barre latérale. N = tâches de cohérence des liens
 * ouvertes en PRODUCTION (casse visible par le public), via {@link useRedirectBadge}. Ne rend rien
 * à zéro. Dans la barre repliée elle se réduit à un point rouge sur l'icône : même comportement
 * que la pastille Tickets.
 */
export const RedirectNavBadge: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
	const count = useRedirectBadge();
	if (count <= 0) return null;
	if (collapsed) {
		return (
			<span
				className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-rose-500 ring-2 ring-white"
				aria-label={`${count} liens cassés en production`}
			/>
		);
	}
	return (
		<span className="ml-auto inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-rose-500 px-1.5 py-0.5 text-xs font-bold text-white">
			{count}
		</span>
	);
};

export default RedirectNavBadge;
